import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

interface LineageProps {
  hasAssemblyHistory: boolean;
}

function Lineage({hasAssemblyHistory}: LineageProps): JSX.Element {
  if (hasAssemblyHistory) {
    return (
      <p className="u-small-spacing-top">
        {'View lineage information in the '}
        <a className="assembly-history-link">Assembly History tab</a>.
      </p>
    );
  } else {
    return (
      <>
        <p className="u-small-spacing-top">No lineage information available.</p>
        <p>
          Create plasmids using the assembly wizard{' '}
          {BenchlingConfig.MOLBIO_REDESIGNED_CLONING_FLOW && 'or combinatorial assembly tool '}
          to store lineage information.
        </p>
      </>
    );
  }
}

export default makeDeprecatedJadeStyleTemplate<LineageProps>(Lineage);
